import Icon, { ICON_NAMES } from "shared/components/utils/Icon";

import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import { StyledSecondaryButton, Wrapper } from "./SecondaryButton.styles";

const SecondaryButton = ({
    label,
    leadingIcon,
    trailingIcon,
    disabled = false,
    fullWidth = false,
    small = false,
    mediumSmall = false,
    ...rest
}) => {
    const ariaLabel = rest["aria-label"];

    if (!label && !ariaLabel) {
        console.error("Icon-only button missing aria-label");
    }

    return (
        <Wrapper fullWidth={fullWidth} disabled={disabled}>
            <Tooltip text={ariaLabel} enabled={!label}>
                <StyledSecondaryButton
                    $reducePadding={!label}
                    disabled={disabled}
                    $fullWidth={fullWidth}
                    $small={small}
                    $mediumSmall={mediumSmall}
                    {...rest}
                >
                    {leadingIcon && <Icon name={leadingIcon} />}
                    {label && <Text variant="Headline_5">{label}</Text>}
                    {trailingIcon && <Icon name={trailingIcon} />}
                </StyledSecondaryButton>
            </Tooltip>
        </Wrapper>
    );
};

SecondaryButton.propTypes = {
    label: PropTypes.string,
    leadingIcon: PropTypes.oneOf(ICON_NAMES),
    trailingIcon: PropTypes.oneOf(ICON_NAMES),
    "aria-label": PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    small: PropTypes.bool,
    mediumSmall: PropTypes.bool,
};

export default SecondaryButton;
